import Request from './Request';

/**
 * コア機能に入れたくないけど、汎用的に使えそうな便利機能。UI関係の操作など。
 *
 */
export default class Controller {

  constructor(options) {
    this.setOptions(options);
  }

  setOptions(options) {
    this.options = _.defaults(options, {
      /**
       * 施設が全て表示されるようにズームするかどうか
       * @type {Boolean}
       */
      fit_bounds: true,
      /**
       * 検索結果数を表示する要素セレクタ
       * @type {string}
       */
      numberOfResultSelector: '.number-of-result'
    });
  }

  apply(ih) {

    // URLハッシュを削除する（ready前に一度だけ実行）
    // モーダル表示時の #&ui-state=dialog が付いたまま再読み込みすると不具合がおきるため
    if (window.location.hash !== '') {
      window.location.replace(window.location.origin + window.location.pathname);
    }

    this.ih = ih;

    $(this.ih).on('ready', () => {
      // 検索方式の切替え (カテゴリ or ファセット)
      if (this.ih.repositoryOptions.type === 'builtin') {

        if (this.ih.renderSearchMenu) {
          // カテゴリ検索メニューを描画する
          this.renderCategorySearchMenu();
        }

      } else if (this.ih.repositoryOptions.type === 'facet') {

        // ファセット検索メニューを描画する
        this.renderFacetSearchMenu();

        if (this.ih.repositoryOptions.firstSelection === '') {
          this.displayNumberOfFacetValue(null, true);
        }
      }

      // パネルの表示調整
      this.readyForPagesAndPanels();

      // モーダルメニューの表示調整
      this.readyForModalMenus();

      // 結果パネル: 並び替えボタンの設定
      this.initSortButton();

      // GoogleMapsの場合、検索したマーカが画面内に収まるよう調整する
      //this.setFitBoundsHook();

      // 検索結果数をフッタの検索ボタンに表示する
      this.displayNumberOfResult();

      // 現在地メニューの処理を設定する
      this.setMoveMapMenus();

      // GoogleMapsの場合、マップ右上に全データ数を表示する
      // カテゴリ検索の場合、検索パネルに各データ数を表示する
      this.setNumberOfDataOnMap();

      if (this.ih.mapOptions.type === 'googlemap') {
        // ストリートビュー表示時は、マーカを非表示にする
        this.clearMarkersOnStreetview();

        // ヘッダに住所を表示する（更新タイミング: アプリロード、中心位置変更）
        if (this.ih.options.show_address) {
          this.displayCurrentAddress();
          google.maps.event.addListener(this.ih.map.getMap(), 'idle', () => {
            this.displayCurrentAddress();
          });
        }
      }

      // 検索パネルの「選択を解除」ボタンを押すと、
      $('#all-clear-button').on('click', () => {

        // 検索メニューを無効化する（ファセット値連打防止用）
        $('.js-search-type').addClass('ui-disabled');

        // 全選択を解除する
        this.clearAllSelector();

        // 検索する（ = 検索結果をクリアする）
        this.ih.searchFromBaseMarker();

      });

      // 検索メニューを有効化する（ファセット値連打防止用）
      $(this.ih.map).on('ihDisplayedAllMarkers', (event, places, marker, popup) => {
        $('.js-search-type').removeClass('ui-disabled');
      });

      // ツールチップ
      $('.js-tooltip').each(function () {
        let base = $(this);
        let trigger = base.find('.js-tooltip-trigger');
        let popup;
        if (base.data('target')) {
          popup = $('#' + $(this).data('target'));
        } else {
          popup = base.find('.js-tooltip-display');
        }
        trigger.on('click touchend', function (e) {
          popup.popup('open', { positionTo: trigger.get() });
          e.stopPropagation();
        });
      });
    });

    $(this.ih).on('ihAfterRequestPlaces', (event, request, places) => {

      // 検索メニューを有効化する（ファセット値連打防止用）
      if (places.length === 0) {
        $('.js-search-type').removeClass('ui-disabled');
      }

      // ファセット検索の場合
      if (this.ih.repositoryOptions.type === 'facet') {
        // 各ファセット値の該当データ数を更新する
        this.displayNumberOfFacetValue(request);
      }
    });
  
    $(this).on('ihAfterUpdateFacetValue', () => {
      this.displayBottomBorderOnLastMenu();
    });
  }

  /**
   * パネルの表示を調整する
   */
  readyForPagesAndPanels() {

    let that = this.ih;
    let width = $(window).width();
    let panelCloser = $('.panel-closer');
    let panel = $('*[data-role=panel]');
    let openPanel = null;
    let adjuster = 140;

    // ウィンドウサイズが指定サイズ以上の時に、サイドパネルの閉じるボタンを非表示にする
    // (マップビューポートをサイドパネル分縮小する設定が有効な場合のみ)
    if (that.mapOptions.adjustView.enable && width >= that.mapOptions.adjustView.viewSize) {
      panelCloser.hide();
    }

    // #home、つまりマップのあるページに戻ってきた時、リサイズイベントを起動する
    $('#home').on('pageshow', function () {
      google.maps.event.trigger(that.map.getMap(), 'resize')
    });

    // パネルを開く時、ストリートビューを閉じる
    if (that.mapOptions.type === 'googlemap') {

      panel.on("panelbeforeopen", (event, ui) => {

        let panorama = that.map.getMap().getStreetView();

        if (panorama) {
          panorama.setVisible(false);
        }

      });

    }

    // パネルを開いた時、パネルコンテンツの高さを調整する
    // fixedにしないと、ウィンドウ全体がスクロールしてしまう
    panel.on('panelopen', function () {

      let outside = $(this).find('.js-outside-content').outerHeight();
      let h = window.innerHeight - adjuster - outside;
      openPanel = $(this);

      $(this).find('.panel-content').height(h);

    });

    panel.on('panelclose', function () {
      openPanel = null;
    });

    // ウィンドウリサイズ時
    // 　・パネルコンテンツの高さを調整する
    // 　・ウィンドウサイズが指定サイズ以上の時に、サイドパネルの閉じるボタンを非表示にする
    //　　　(マップビューポートをサイドパネル分縮小する設定が有効な場合のみ)
    $(window).bind("resize", function (event) {

      if (openPanel) {
        let outside = openPanel.find('.js-outside-content').outerHeight();
        let h = window.innerHeight - adjuster - outside;
        openPanel.find('.panel-content').height(h);
      }

      width = $(window).width();
      if (that.mapOptions.adjustView.enable && width >= that.mapOptions.adjustView.viewSize) {
        panelCloser.hide();
      } else {
        panelCloser.show();
      }

    });

    // パネルを常に開く場合、閉じないようにする。
    panel.on('panelbeforeopen', function (event) {
      console.log('beforeopen');
    });
    panel.on('panelbeforeclose', function (event) {
      console.log('beforeclose');
    });
    panel.on('panelopen', function (event) {
      console.log('open');
    });
    panel.on('panelclose', function (event) {
      console.log('close');
      // if (that.isAlwaysPanelShow()){
      //   $(event.target).panel('open');
      // }
    });

    // アコーディオンメニューにアニメーションをつける
    let panelContent = $('.panel-content');
    panelContent.on('expand', '.ui-collapsible', function () {
      $(this).children().next().hide();
      $(this).children().next().slideDown(200);
    });
    panelContent.on('collapse', '.ui-collapsible', function () {
      $(this).children().next().slideUp(200);
    });

    // 拡大した結果一覧の高さを調整
    // 並び替えボタンのスクロール固定に必要
    let outsideX = $('.ih-list-controller').outerHeight();
    let hX = window.innerHeight - 100 - outsideX;
    $('.ih-expanded-tiled-result-content').height(hX);
  }

  /**
   * モーダルメニューの表示を調整する
   */
  readyForModalMenus() {

    let popupLocation = $('#page-location');  // 「現在地」
    let popupInfo = $('#popup-info');         // 「情報」

    // モーダルメニューオープン時に背景に色を着ける
    popupLocation.popup({
      overlayTheme: "a"
    });
    popupInfo.popup({
      overlayTheme: "a"
    });

    // モーダルメニューから項目を選ぶと、メニューを閉じる
    $('.js-close-popup').on('click', () => {
      popupInfo.popup('close');
    });

    // モーダルメニューオープン時、ウィンドウサイズが変ると、メニューを閉じる
    popupLocation.on('popupbeforeposition', function (event, ui) {

      $(window).resize(function () {
        popupLocation.popup('close');
      });

    });
    popupInfo.on('popupbeforeposition', function (event, ui) {

      $(window).resize(function () {
        popupInfo.popup('close');
      });

    });
  
    // 情報メニュー(ハンバーガーメニュー版)
    $('.hz-info-menu').on('click', () => {
      $('.hz-info-menu-img').addClass('hz-info-menu-open');
    });
    const popup = $('.hz-info-menu-popup');
    popup.on('popupbeforeposition', () => {
      popup.removeClass('ui-corner-all');
      popup.parents('#popup-info-popup').addClass('hz-info-menu-reposition');
    });
    popup.on('popupafterclose', () => {
      $('.hz-info-menu-img').removeClass('hz-info-menu-open');
    });
    
    // 言語選択メニュー オープン時にデフォルトフォーカスされる選択肢のデザイン解除
    const $localeSelection = $('.ui-selectmenu.ui-popup');
    $localeSelection.on('popupafteropen', () => {
      setTimeout(()=>{
        const $focusedOption = $localeSelection.find('.ui-selectmenu-list.ui-listview li.ui-focus')
        $focusedOption.removeClass('ui-btn-down-f')
        $focusedOption.removeClass('ui-focus')
      }, 100)
    })
    // 言語選択メニュー ページ遷移
    // ネイティブセレクトメニューをOFFにすることでjQueryのメニュー要素(アンカーリンク)が優先されてしまうため、時差でページ遷移処理する
    $('.hz-locale-select').on('change',function() {
      setTimeout(()=>{
        window.location.href = $(this).val();
      }, 100)
    });
  }

  /**
   * ファセット検索画面の項目一覧を描画する
   *  ・検索方式: ファセット検索専用
   *  ・マップ: GoogleMaps、OpenLayers共通
   */
  renderFacetSearchMenu() {

    let self = this;
    let that = this.ih;
    let elem = $('.js-search-type');
    let categories = {};

    elem.controlgroup({
      create() {
      }
    });

    that.placeType.getAll().forEach(function (type) {

      let container = elem.controlgroup('container');

      if (type.category && !categories[type.category.id]) {

        // ファセットが非表示指定 (display: 0) でなければファセットを描画
        if (type.category.display != 0) {

          // ファセットオブジェクト
          let facet = type.category;

          // ファセットを表示する要素 (fct from FaCeT)
          let fctElem = $('<label class="category-label"></label>');

          // ファセットそのもののチェックボックス
          // ファセット検索では、チェックボックスは非表示にし、機能も無効にする
          let fctCheckbox =
            $('<input type="checkbox" data-theme="e" data-category="' + facet.id + '" class="js-facility-category" />');
          //.text(facet.name);

          // ファセットの描画
          fctElem.append($('<span></span>').text(facet.name));
  
          // ファセットの開閉マークを描画する
          const $collapseMarker = $('<span class="ih-collapsible-search-menu-marker" id="ih-collapsible-search-menu-marker-' + facet.id + '"></span>');
          $collapseMarker.data('collapse', false);
          $collapseMarker.data('facetId', facet.id);
          $collapseMarker.text('▼');
          fctElem.append($collapseMarker);

          // ファセットチェックボックスの描画
          fctElem.append(fctCheckbox);

          // ファセット要素の描画
          container.append(fctElem);

          fctCheckbox.checkboxradio();
          categories[facet.id] = facet;
  
          // ファセット値をリストごと開閉する
          fctCheckbox.on('click', function () {
            let checkbox = null;
            let checkedItem = null;
            
            // ファセットの開閉マークを切り替える
            if ( $collapseMarker.data('collapse') ) {
              $collapseMarker.data('collapse', false);
              $collapseMarker.text('▼');
            } else {
              $collapseMarker.data('collapse', true);
              $collapseMarker.text('▲');
            }
            
            $('.js-facet-selector').each(function () {
              if ( $(this).data('category') === facet.id ) {
                checkbox = $(this).closest('.ui-checkbox');
                // 選択中の値やその下位階層の値は常に表示したまま
                if ( $(this).prop('checked') ) {
                  checkedItem = $(this).data('placetype');
                } else if ( $(this).data('parent_id') && $(this).data('parent_id') === checkedItem && !$(this).data('hide') ) {
                  checkbox.show();
                } else if (!$(this).data('hide')) {
                  checkbox.toggle();
                }
              }
            });
          });
        }
      }

      // 非表示指定値を持つファセット値（描画中のファセット値に該当するもの）を取得
      // 　・描画中のファセット値オブジェクト(type)は非表示指定値を持っていない
      // 　・typeが持つファセットオブジェクト(type.category)の中のファセット値
      // 　　オブジェクト(type.category.items)の各ファセット値は非表示指定値を
      // 　　持っている
      let _facet = _.find(type.category.items, function (itm) {
        return itm.id == type.id;
      });
      //console.log(_facet);
      //console.log(type);

      // ファセット値、及びそのファセット値が属するファセットが非表示指定でなければ、ファセット値を描画
      if (type.category.display != 0 && _facet.display != 0) {

        //ファセット値の親要素を調べる
        let facet_id = type.id;
        let parent;
        let parent_id;
        type.category.items.forEach(function (item) {
          //parent_idを取得
          if (item.parent_id && facet_id == item.id) {
            parent_id = item.parent_id;
          }
        });
        if (parent_id) {
          //parent_idから親要素を取得
          type.category.items.forEach(function (item) {
            if (item.id == parent_id) {
              parent = item;
            }
          });
        }


        // ファセットを表示する要素 (fcv from FaCetValue)
        let fcvElem = $('<label class="js-tooltip" data-last-child="false" data-target="place-help-' + type.id + '" parent-id="' + parent_id + '"></label>');

        // 検索結果数を表示する要素
        let cntElem = $('<span class="js-facet-count search-count-circle" data-placetype="' + type.id + '">0</span>');

        // ファセット値のチェックボックス
        let fcvCheckbox = $('<input type="checkbox" data-mini="true" class="js-facet-selector" />'); // js-facility-selector

        // ファセットIDの付与
        fcvCheckbox.data('category', type.category.id);
        // ファセット値IDの付与
        fcvCheckbox.data('placetype', type.id);
        if (parent_id) {
          fcvCheckbox.data('parent_id', parent_id);
        }
        fcvCheckbox.data('hide', false);

        // ファセット値をチェックすると検索開始
        fcvCheckbox.on('change', function () {

          // 検索メニューを無効化する（ファセット値連打防止用）
          $('.js-search-type').addClass('ui-disabled');

          // キーワード検索を初期化する
          if (self.ih.keywordSearchMode) {
            self.ih.initKeywordSearchUI();
          }

          $(this).trigger('changeState');
          that.searchFromBaseMarker();

        });

        // ファセット値チェック状態オブジェクトの値を変更
        fcvCheckbox.on('changeState', function () {

          let placetype = $(this).data('placetype');
          //that.flag_display_facility[placetype] = $(this).get(0).checked;
  
          // 同一ファセット内で値を選択する時、別の選択済みの値の選択を解除する
          // 複数の値を選択できないようにするため
          let itemId = null;
          $('.js-facet-selector').each(function () {
            if ( $(this).data('category') === type.category.id ) {
              itemId = $(this).data('placetype');
              if ( that.searchTargetTypes[itemId] && itemId !== placetype) {
                $(this).prop('checked', false);
                $(this).checkboxradio();
                $(this).checkboxradio('refresh');
                that.searchTargetTypes[itemId] = false;
              }
            }
          });
          
          that.searchTargetTypes[placetype] = $(this).get(0).checked;

          // let checked = $(this).get(0).checked;
          // self.searchTargetTypes[placetype] = checked;

          // 検索パネルの「選択を解除」ボタンの有効・無効を切り替える
          self.toggleAllClearButton();

        });

        fcvCheckbox.on('click', function () {
          this.blur();
          this.focus();
        });

        // 初期選択ファセット値があれば即検索
        if (type.checked) {
          fcvCheckbox.prop('checked', true);
          fcvCheckbox.trigger('changeState');
        }

        fcvElem.append(cntElem);
        fcvElem.append(fcvCheckbox);

        //親のファセット値がある場合に表示を変更する
          fcvElem.append($(
            // <img src="'+type.icon_min+'" alt="" class="icon-small js-placetype-icon" data-placetype="'+type.id+'" />
            '<span>' + type.name + '</span>'
          ));
        /*if (!parent) {
        } else {
          fcvElem.append($('<span>' + parent.name + ' => ' + type.name + '</span>'));
        }
        */

        // ツールチップ生成
        if (that.tooltipData) {
          let tooltip = _.find(that.tooltipData, { type: type.name });
          if (tooltip) {
            // ツールチップ表示ボタン
            let tooltipTrigger =
              $('<a class="js-tooltip-trigger" data-role="button" data-theme="f" data-icon="info" data-iconpos="notext" ' +
                'data-inline="true" data-corners="true" data-shadow="true" data-iconshadow="true" data-wrapperels="span" title=""></a>');
            tooltipTrigger.buttonMarkup("refresh");
            fcvElem.append(tooltipTrigger);

            // ツールチップヘッダ（ファセット値名、閉じるボタン）
            let tooltipHeader = $('<div class="ih-tooltip-header"></div>');
            let tooltipCloser = $('<button data-theme="b" data-rel="back" class="ih-tooltip-closer ui-btn ui-corner-all ui-shadow ui-btn-inline ui-btn-up-b"></button>');
            tooltipCloser.text(that.translationsCommon.template.common.close);
            tooltipHeader.append($('<b class="ih-tooltip-title"></b>').text(type.name));
            tooltipHeader.append(tooltipCloser);

            // ツールチップ本体
            let tooltipContainer = $('<div class="js-tooltip-display" data-role="popup" id="place-help-' + type.id + '">');
            elem.append(tooltipContainer);
            tooltipContainer.append(tooltipHeader);
            tooltipContainer.append($('<p></p>').html(tooltip.description));
            tooltipContainer.popup();
            tooltipCloser.buttonMarkup("refresh");

            tooltipCloser.on('click', function () {
              tooltipContainer.popup('close');
            });
          }
        }

        container.append(fcvElem);
        fcvCheckbox.checkboxradio();

      }

    });

    // 下位階層の並べ替え
    $('.js-tooltip').each( function () {
      if ($(this).attr('parent-id') !== 'undefined') {
        let parentId = $(this).attr('parent-id');
        let lastChild = null;
        
        $(this).addClass('child');
        $(this).css('padding-left','20px');
  
        // 並べ替え済みの下位階層が存在するか
        $('.js-tooltip').each( function () {
          if ( $(this).attr('parent-id') === parentId && $(this).data('last-child') ) {
            lastChild = $(this);
            $(this).data('last-child', false);
            return false;
          }
        });
  
        // 並べ替え済みの下位階層があればその直後に、無ければ上位階層の直後に配置
        if (lastChild) {
          $(this).parent().insertAfter(lastChild.parent());
        } else {
          $(this).parent().insertAfter( $('.js-tooltip[data-target ="place-help-' + parentId + '"]').parent() );
        }
  
        $(this).data('last-child', true);
      }
    });

    elem.controlgroup('refresh');

    // 検索パネルの「選択を解除」ボタンの有効・無効を切り替える
    self.toggleAllClearButton();

  }

  /**
   * カテゴリ検索画面の項目一覧を描画する
   *  ・検索方式: カテゴリ検索専用
   *  ・マップ: GoogleMaps、OpenLayers共通
   */
  renderCategorySearchMenu() {

    let self = this;
    let that = this.ih;
    let elem = $('.js-search-type');
    let categories = {};

    elem.controlgroup({
      create() { }
    });

    that.placeType.getAll().forEach(function (type) {

      let container = elem.controlgroup('container');

      // カテゴリの描画
      // TODO: カテゴリ検索の場合、type.categoryはオブジェクトではなくカテゴリ名 [2017.5.26] (a)
      // if (type.category && !categories[type.category.id]) {
      if (type.category && !categories[type.category]) {

        // カテゴリ名
        let category = type.category;

        // カテゴリを表示する要素
        let catElem = $('<label class="category-label"></label>');

        // TODO: (a)
        // カテゴリそのもののチェックボックス
        // カテゴリ検索では、チェック機能は有効のままで、チェックボックスの表示・非表示をCSSで切替る
        let catCheckbox =
          $('<input type="checkbox" data-theme="e" data-category="' + category + '" class="js-facility-category" />')
            .text(category);
        // $('<input type="checkbox" data-theme="e" data-category="'+category.id+'" class="js-facility-category" />')
        // .text(category.name);

        // カテゴリをチェックすると、カテゴリ以下の全ての項目を検索
        catCheckbox.on('change', function () {

          let checked = $(this).prop('checked');

          // TODO: (a)
          $('.js-facility-selector').each(function () {
            // if ($(this).data('category') === category.id){

            if ($(this).data('category') === category) {
              $(this).prop('checked', checked);
              //$(this).prop('checked', false); // on/offは一貫性ないように見えるので、常に項目内全て非選択
              $(this).trigger('changeState');
              $(this).checkboxradio();
              $(this).checkboxradio("refresh");
            }
          });
          that.searchFromBaseMarker();
        });

        // TODO: (a)
        // カテゴリ名の描画
        catElem.append($('<span></span>').text(category));
        //catElem.append($('<span></span>').text(category.name));

        // カテゴリチェックボックスの描画
        catElem.append(catCheckbox);

        // カテゴリ要素の描画
        container.append(catElem);

        catCheckbox.checkboxradio();

        // TODO: (a)
        categories[category] = category;
        // categories[category.id] = category;

      }

      // カテゴリの各項目の描画
      // カテゴリが未設定の場合は描画しない
      if (type.category) {

        // カテゴリの項目（値）を表示する要素
        let itemElem = $('<label class="js-tooltip" data-target="place-help-' + type.id + '"></label>');
        // 検索結果数を表示する要素
        let cntElem = $('<span class="js-search-count search-count-circle" data-placetype="' + type.id + '">0</span>');
        // カテゴリの項目のチェックボックス
        let itemCheckbox = $('<input type="checkbox" data-mini="true" class="js-facility-selector" />'); // js-facility-selector

        // TODO: (a)
        // カテゴリIDの付与
        itemCheckbox.data('category', type.category);
        // itemCheckbox.data('category', type.category.id);

        // 項目IDの付与
        itemCheckbox.data('placetype', type.id);

        // 項目をチェックすると検索開始
        itemCheckbox.on('change', function () {
          $(this).trigger('changeState');
          that.searchFromBaseMarker();
        });

        // 検索項目チェック状態オブジェクトの値を変更
        itemCheckbox.on('changeState', function () {

          let placetype = $(this).data('placetype');
          that.flag_display_facility[placetype] = $(this).get(0).checked;

          // 検索パネルの「選択を解除」ボタンの有効・無効を切り替える
          self.toggleAllClearButton();

        });

        itemCheckbox.on('click', function () {
          this.blur();
          this.focus();
        });

        // 初期選択項目があれば即検索
        if (type.checked) {
          itemCheckbox.prop('checked', true);
          itemCheckbox.trigger('changeState');
        }

        // TODO ヘルプ、うまく配置できない
        // if (type.help){
        //   var link = $('<a class="js-tooltip-trigger" href="#" data-role="button" data-theme="b" data-icon="info" data-iconpos="notext" data-inline="true"></a>');
        //   item.append();
        // }
        // <input type="checkbox"
        // data-mini="true"
        // class="js-facility-selector"
        // data-category="<?php echo $key ?>"
        // data-placetype="<?php echo $place->id ?>" <?php if ($place->checked) { ?>checked="checked"<?php } ?> />

        itemElem.append(cntElem);
        itemElem.append(itemCheckbox);
        itemElem.append($(
          '<img src="' + that.icon_file_path + type.icon_min + '" alt="" class="icon-small js-placetype-icon" data-placetype="' + type.id + '" /> ' +
          '<span>' + type.name + '</span>'
        ));

        // if (type.help){
        //   var tooltip = $('<div class="js-tooltip-display" data-role="popup" id="place-help-'+type.id+'">');
        //   tooltip.append('<a href="#" data-rel="back" data-role="button" data-theme="a" data-icon="delete" data-iconpos="notext" class="ui-btn-right">Close</a>');
        //   tooltip.append(
        //     $('<h5></h5>')
        //       .append('<img src="'+type.icon_min+'" alt="" class="icon-small" />')
        //       .append($('<span></span>').text(type.name))
        //   );
        //   tooltip.append($('<p></p>').text(type.help));
        //   elem.append(tooltip);
        // }

        container.append(itemElem);
        itemCheckbox.checkboxradio();

      }

    });

    elem.controlgroup('refresh');

    // 検索パネルの「選択を解除」ボタンの有効・無効を切り替える
    self.toggleAllClearButton();

  }
  
  displayBottomBorderOnLastMenu () {
    $('.ih-last-facet-value').each((index, element) => {
      $(element).removeClass('ih-last-facet-value');
    });
    const $lastDisplayedFacet = $('.js-search-type .ui-checkbox[style!="display: none;"] .category-label').slice(-1);
    const $lastDisplayedFacetValue = $('.js-search-type .ui-checkbox[style!="display: none;"]').slice(-1).find('label');
    $lastDisplayedFacet.addClass('ih-last-facet-value');
    $lastDisplayedFacetValue.addClass('ih-last-facet-value');
  }
  
  /**
   * 検索パネルのメニュー選択を全て解除
   *  ・検索方式: カテゴリ検索、ファセット検索共通
   *  ・マップ: GoogleMaps、OpenLayers共通
   */
  clearAllSelector() {

    let that = this;

    // カテゴリ検索
    if (this.ih.repositoryOptions.type === 'builtin') {

      // カテゴリチェックボックスを解除する
      $('.js-facility-category').each(function () {

        $(this).prop('checked', false);
        $(this).checkboxradio();
        $(this).checkboxradio('refresh');

      });

      // 項目チェックボックスを解除する
      $('.js-facility-selector').each(function () {

        let placetype = $(this).data('placetype');

        that.ih.flag_display_facility[placetype] = false;

        $(this).prop('checked', false);
        $(this).checkboxradio();
        $(this).checkboxradio('refresh');

      });

      // ファセット検索
    } else if (this.ih.repositoryOptions.type === 'facet') {

      // ファセット値チェックボックスを解除する
      $('.js-facet-selector').each(function () {

        let placetype = $(this).data('placetype');

        that.ih.searchTargetTypes[placetype] = false;

        $(this).prop('checked', false);
        $(this).checkboxradio();
        $(this).checkboxradio('refresh');

      });
    }

    // 検索パネルの「選択を解除」ボタンの有効・無効を切り替える
    this.toggleAllClearButton();

  }

  /**
   * 検索パネルの「選択を解除」ボタンの 有効/無効 を切替える
   *  ・検索方式: カテゴリ検索、ファセット検索共通
   *  ・マップ: GoogleMaps、OpenLayers共通
   */
  toggleAllClearButton() {

    // 詳細パネル >「選択を解除」ボタンを無効化・グレーアウトする
    $('#all-clear-button').prop('disabled', true);
    $('#all-clear').find('.ui-btn-inner').css('color', 'darkgray');

    // カテゴリ検索: 項目が選択されている時のみ、「選択を解除」ボタンを有効化する
    if (this.ih.repositoryOptions.type === 'builtin') {

      $('.js-facility-selector').each(function () {

        if ($(this).prop('checked')) {
          $('#all-clear-button').prop('disabled', false);
          $('#all-clear').find('.ui-btn-inner').css('color', 'black');
        }

      });

      // ファセット検索: ファセット値が選択されている時のみ、「選択を解除」ボタンを有効化する
    } else if (this.ih.repositoryOptions.type === 'facet') {

      $('.js-facet-selector').each(function () {

        if ($(this).prop('checked')) {
          $('#all-clear-button').prop('disabled', false);
          $('#all-clear').find('.ui-btn-inner').css('color', 'black');
        }

      });

    }

  }

  /**
   * 結果パネル: デフォルトの並び替えと並び替えボタンの、キーと順序を設定
   *  ・検索方式: カテゴリ検索、ファセット検索共通
   *  ・マップ: GoogleMaps、OpenLayers共通
   */
  initSortButton() {
    let that = this.ih;
    let sortButton = $('select.ih-result-sort-menu');

    // デフォルトの並び替え
    that.repository.sortOrder = that.defaultSortOrder;
    that.repository.sortKey = that.defaultSortKey;

    sortButton.on('change', function () {
      let option = parseInt($(this).val());

      if (option === 1) {
        that.repository.sortOrder = that.sortOrder_1;
        that.repository.sortKey = that.sortKey_1;
        sortButton.val('1').selectmenu('refresh');
      } else if (option === 2) {
        that.repository.sortOrder = that.sortOrder_2;
        that.repository.sortKey = that.sortKey_2;
        sortButton.val('2').selectmenu('refresh');
      } else {
        return;
      }

      if (that.keywordSearchMode) {
        that.displayKeywordSearchResults(that.searchWord);
      } else {
        that.reSearch();
      }
    });
  }

  /**
   * 検索後、フッタの検索ボタンに検索結果数を表示する
   *  ・検索方式: カテゴリ検索、ファセット検索共通
   *  ・マップ: GoogleMaps、OpenLayers共通
   */
  displayNumberOfResult() {

    let that = this.ih;

    $(that).on('ihAfterRequestPlaces', (event, request, places) => {

      if (places) {

        let num = places.length;

        $(this.options.numberOfResultSelector).text(" (" + num + ")");

      } else {

        $(this.options.numberOfResultSelector).text("");

      }
    });
  }

  /**
   * マップ右上に全データ数を表示する準備をする
   *  ・検索方式: カテゴリ検索、ファセット検索共通
   *  ・マップ: GoogleMaps専用
   *  ・TODO: OpenLayersでも表示できるようにする？ [2017.5.29]
   */
  setNumberOfDataOnMap() {

    let that = this.ih;

    // 現在地点の現在半径の、件数を表示する
    if (!that.showNumberOfPlaces) {
      return;
    }

    // Create the DIV to hold the control and call the HomeControl() constructor
    // passing in this DIV.
    let homeControlDiv = document.createElement('div');
    $(homeControlDiv).addClass("number-of-places").text('0');
    homeControlDiv.index = 1;

    if (that.mapOptions.type === 'googlemap') {
      that.map.getMap().controls[google.maps.ControlPosition.RIGHT_TOP].push(homeControlDiv);
    }

    that.centerChangeRequesting = false;

    this.displayNumberOfDataOnMap(homeControlDiv);

  }

  /**
   * マップ右上に全データ数を表示する (※ カテゴリ検索の場合、検索パネルに各データ数も表示する)
   *  ・検索方式: カテゴリ検索、ファセット検索共通
   *  ・マップ: GoogleMaps専用
   *  ・TODO: OpenLayersでも表示できるようにする？ [2017.5.29]
   */
  displayNumberOfDataOnMap(homeControlDiv) {

    let that = this.ih;
    let self = this;
    let types = [];

    if (that.centerChangeRequesting) {
      return;
    }

    that.centerChangeRequesting = true;

    // 全タイプの結果を求める
    for (let i = 0; i < that.placeTypes.length; i++) {
      types.push(i);
    }

    let request = new Request({
      latlng: that.map.getCenter(),
      radius: that.getRadius(),
      type: types,
      origin: 'system'
    });

    that._search(request)
      .then(function (json) {

        let places = json.places;

        // カテゴリ検索の場合、検索パネルに各データ数を表示する
        // ファセット検索の場合は絞込みによる更新が必要なので、独立したメソッドを使用する
        if (that.repositoryOptions.type === 'builtin') {
          self.displayNumberOfDataOnPanel(places);
        }

        $(homeControlDiv).text(places.length);
        that.centerChangeRequesting = false;

      })
      .catch(function () {
        $(homeControlDiv).text('0');
        // }).done(function(){
        //   centerChangeRequesting = false;
        // }).fail(function(){
        //   $(homeControlDiv).text('0');
      });
  }

  /**
   * ファセット値とそのデータ件数を描画する（以下の描画条件を満たす場合）
   * ・ファセット値に該当するデータがある
   * ・選択済みのファセット値とは異なるファセットに属する
   * ・下位階層を持つ場合、下位のファセット値が未選択
   * @param request
   * @param triggerEvent
   */
  displayNumberOfFacetValue(request, triggerEvent = true) {
    const that = this;
    let types = [];
  
    // 初期化（全ファセット値表示 -> データ0件の場合は永久非表示）
    $('.js-facet-selector').each(function () {
      $(this).data('hide', false);
      $(this).closest('.ui-checkbox').show();
    });
    $('.ih-collapsible-search-menu-marker').each(function () {
      $(this).text('▼');
      $(this).data('collapse', false);
    });
    this.ih.repository.getFacetCount(this.ih.repository.buildFacetQuery(null)).then( counts => {
      _.forEach(counts, function(obj){
        const $counter = $('.js-facet-count[data-placetype="' + obj.id + '"]');
        const $checkbox = $counter.closest('.ui-checkbox');
        const $selector = $checkbox.find('.js-facet-selector');
        if (obj.count) {
          $counter.text(obj.count);
          $selector.data('hidePermanently', false);
        } else {
          $checkbox.hide();
          $selector.data('hide', true);
          $selector.data('hidePermanently', true);
        }
      });
      if ( triggerEvent && (!request || request.opt.types.length === 0) ) {
        $(that).trigger('ihAfterUpdateFacetValue');
      }
    });
    
    // 選択したファセット値ごとに個別に、他のファセット値の非表示処理を行う
    // ・データ件数が0のファセット値を非表示にする
    // ・非表示は以下の2種類
    // 　(1) 開閉ボタンで再表示可能な一時非表示: 選択したファセット値と同じファセットに属する他のファセット値が対象( -> 絞り込みをわかるやすくするため)
    // 　(2) 常時非表示: 選択したファセット値と異なるファセットに属する他のファセット値が対象( -> 組み合わせ不可能な値の除外)
    // ・複数選択の場合(1)と(2)を区別できないので、選択済みのファセット値ごとに個別に検索リクエストをかけて非表示設定を行う
    if ( request && request.opt.types.length > 0 ) {
      types = request.opt.types;
      for (let i = 0; i < types.length; i++) {
        request.opt.types = [types[i]];
        this.ih.repository.getFacetCount(this.ih.repository.buildFacetQuery(request)).then(counts => {
          _.forEach(counts, obj => {
            const $counter = $('.js-facet-count[data-placetype="' + obj.id + '"]');
            let checkbox = $counter.closest('.ui-checkbox');
            let selector = checkbox.find('.js-facet-selector');
            let hasSelectedChild = this.hasSelectedChildren(obj.id);
  
            // 選択したファセット値と同じファセットに属するファセット値は非表示とし、メニューをクローズ状態にする（マークを閉(▲)にする）
            // 手動でオープン可能
            if (types[i] != obj.id && that.isSameFacet(types[i], obj.facet_id)) {
              checkbox.hide();
              let collapsibleMarker = $('#ih-collapsible-search-menu-marker-' + obj.facet_id);
              collapsibleMarker.text('▲');
              collapsibleMarker.data('collapse', true);
            }
            
            // 以下のファセット値を非表示とする
            // ・元からデータ0件(hidePermanently)のファセット値【常時非表示】
            // ・選択したファセット値と異なるファセットに属するデータ0件ファセット値【常時非表示】
            // ・選択済の子を持つ親ファセット値（子のみ表示）【手動でオープン可能】
            if (!obj.count || hasSelectedChild) {
              checkbox.hide();
              if ( selector.data('hidePermanently') || (!that.isSameFacet(types[i], obj.facet_id) && !hasSelectedChild) ) {
                selector.data('hide', true);
              }
            }
            if (obj.count) {
              $counter.text(obj.count);
              // 親ファセット値が選択状態の場合は子ファセット値を表示する
              const $label = checkbox.find('.js-tooltip');
              if ($label.hasClass('child')) {
                const parentId = $label.attr('parent-id');
                const parentSelector = $('.js-tooltip[data-target=place-help-' + parentId + ']').siblings('.js-facet-selector');
                if (parentSelector.prop('checked')) {
                  checkbox.show();
                }
              }
            }
          });
      
          // 個別ファセット値の非表示処理後、元の検索条件でリクエストし
          // (1) 複数ファセット値選択時にデータ件数0になる値の常時非表示処理を行う
          // (2) 最終的なデータ件数を表示する
          // (3) ファセット値更新完了イベント ihAfterUpdateFacetValue 実行
          if (i+1 === types.length) {
            request.opt.types = types;
            this.ih.repository.getFacetCount(this.ih.repository.buildFacetQuery(request)).then(counts => {
              _.forEach(counts, obj => {
                const counter = $('.js-facet-count[data-placetype="' + obj.id + '"]');
                if (obj.count) {
                  counter.text(obj.count);
                } else if (!obj.count && types.length > 1) {
                  let isSameFacet = false;
                  for (let i = 0; i < types.length; i++) {
                    isSameFacet = that.isSameFacet(types[i], obj.facet_id);
                    if (isSameFacet) {
                      break;
                    }
                  }
                  if (!isSameFacet) {
                    let checkbox = counter.closest('.ui-checkbox');
                    let selector = checkbox.find('.js-facet-selector');
                    checkbox.hide();
                    selector.data('hide', true);
                  }
                }
              });
              if (triggerEvent) {
                $(that).trigger('ihAfterUpdateFacetValue');
              }
            });
          }
        });
      }
    }
  }
  
  /**
   * 選択済みのファセット値の上位ファセットかどうかを判定する
   * @param itemId
   * @returns {boolean}
   */
  hasSelectedChildren (itemId) {
    let has = false;
    $('.js-facet-selector').each(function () {
      if ($(this).prop('checked')) {
        let parentId = $(this).data('parent_id');
        if (parentId == itemId) {
          has = true;
        }
      }
    });
    return has;
  }
  
  /**
   * 対象のファセット値が、指定したファセットに属するか判定
   * @param itemId
   * @param facetId
   * @returns {boolean}
   */
  isSameFacet (itemId, facetId) {
    let is = false;
    $('.js-facet-selector').each(function () {
      if ($(this).data('placetype') == itemId && $(this).data('category') == facetId ) {
        is = true;
      }
    });
    return is;
  }

  /**
   * 検索パネルに各データ数を表示する
   *  ・検索方式: カテゴリ検索専用
   *  ・マップ: GoogleMaps、OpenLayers共通
   */
  displayNumberOfDataOnPanel(places) {

    let countTable = {};

    $.each(places, function () {

      let p = this;

      if (typeof countTable[p.type] === 'undefined') {
        countTable[p.type] = 0;
      }

      countTable[p.type]++;

    });

    $('.js-search-count').each(function () {

      let sc = $(this);
      let type = sc.data('placetype');

      if (countTable[type]) {
        sc.text(countTable[type]);
      } else {
        sc.text(0);
      }

    });

  }

  displayCurrentAddress() {

    let locationBar = $('.ih-location-bar-address');

    locationBar.text('');

    this.ih.getAddress(this.ih.map.getCenter(), address => {
      locationBar.text(address.replace(/日本、/g, ''));
    });

  }

  /**
   * ストリートビュー表示時は、マーカを非表示にする
   */
  clearMarkersOnStreetview() {
    let streetView = this.ih.map.getMap().getStreetView();
    let that = this.ih;

    streetView.addListener("visible_changed", () => {
      let svVisible = streetView.getVisible();
      let facilityMarker = that.map.getDisplayMarkers();
      let staticMarker = that.map.getStaticMarkers();

      if (svVisible) {
        if (facilityMarker) {
          $.each(facilityMarker, function () {
            this.setMap(null);
          });
        }
        if (staticMarker) {
          $.each(staticMarker, function () {
            this.setMap(null);
          });
        }
      }
      if (!svVisible) {
        if (facilityMarker) {
          $.each(facilityMarker, function () {
            this.setMap(that.map.getMap());
          });
        }
        if (staticMarker) {
          $.each(staticMarker, function () {
            this.setMap(that.map.getMap());
          });
        }
      }
    });
  }

  /**
   *
   * 検索後にすべての施設、基準位置がマップ上に表示されるようにする
   */
  setFitBoundsHook() {
    var that = this.ih;
    if (this.options.fit_bounds) {
      $(that).on('ihAfterRequestPlaces', (event, req, places) => {
        that.map.fitBounds(places);
      });
    }
  }

  /**
   * メニューの「現在地」
   */
  setMoveMapMenus() {

    var that = this.ih;

    // 地図中心を現在地にする
    // $('.js-move-map-center').on('click', () => {
    //   var latlng = that.map.getCenter();
    //   that.map.updateCurrentLocation(latlng);
    //
    //   that.reSearch({lat: latlng.lat(), lng: latlng.lng()}).then((res) => {
    //     $(that).trigger('ihUpdateCenterMarker', res);
    //   });
    //   $(this).closest('.ui-popup').popup('close');
    // });

    // 現在地マーカの位置に移動
    // $('.js-move-center').on('click', () => {
    //   var loc = that.map.getCurrentSearchLocation();
    //   that.map.moveMap(loc.lat(), loc.lng());
    //   $(this).closest('.ui-popup').popup('close');
    // });

    // GPS現在地連動モードに移行
    // $('.js-user-location').on('click', function() {
    //   var elm = $(this);
    //   that.shiftToLocationMode().then(function(){
    //     elm.closest('.ui-popup').popup('close');
    //   });
    //   return false;
    // });

    // 現在地マーカの表示有効範囲（動物園内）
    var minLat = 34.6483;
    var minLng = 135.5066;
    var maxLat = 34.6538;
    var maxLng = 135.5097;

    // 「自動的に取得」ボタンによる現在地自動更新を停止するID
    var watchID = null;

    // Todo OL依存のため、一時的にControllerからの現在地機能は停止し、sakaimapで処理
    // 　　　今後、GoogleMapでも使用できるようにしたい。
    // 「自動的に取得」ボタン: GPSで取得した現在地にマーカを設置
    $('.js-user-location').on('click', function () {

      // TODO: IHCityTakatsukiに処理が割当てらているため、一旦無効にする
      return false;

      // 初期化（GPS追跡停止、現在地マーカ非表示）
      $('.js-move-center').trigger("click");

      // 端末・ブラウザから現在地を取得できない場合はエラーを表示
      if (!navigator.geolocation) {
        alert("お使いの端末やブラウザでは現在地を取得できません。");
      } else {

        that.displayLoading(true);

        // GPSで実際の現在地座標を取得
        watchID = navigator.geolocation.watchPosition(successCallback, errorCallback, {
          enableHighAccuracy: true,    // 高精度を要求する
          timeout: 15000,              // 最大待ち時間（ミリ秒）
          maximumAge: 0                // キャッシュ有効期間（ミリ秒）
        });

        // GPSで実際の現在地座標の取得に成功した場合
        function successCallback(position) {

          var lat = position.coords.latitude;
          var lng = position.coords.longitude;

          // 実際の現在地が表示有効範囲内の場合
          if (
            lat > minLat &&
            lng > minLng &&
            lat < maxLat &&
            lng < maxLng
          ) {

            // 現在地マーカを表示
            var currentLoc = that.map.createLatLng(lat, lng);
            that.map.displayCurrentLocationMarker(currentLoc);

            // 現在地マーカ非表示ボタンを有効化
            $('.js-move-center').css('color', 'black');

            // 実際の現在地が表示有効範囲外の場合
          } else {

            alert('対象範囲外です。');

            // 初期化（GPS追跡停止、現在地マーカ非表示）
            $('.js-move-center').trigger("click");

          }

          that.displayLoading(false);

        }

        // GPSで実際の現在地座標の取得に失敗した場合、エラーメッセージを表示
        function errorCallback(error) {

          alert('現在地の取得に失敗しました: ' + error.message);

          // 初期化（GPS追跡停止、現在地マーカ非表示）
          $('.js-move-center').trigger("click");

          that.displayLoading(false);

        }

      }

      $(this).closest('.ui-popup').popup('close');

    });

    // 「地図中心に設定」ボタン: 閲覧中の地図の中心に現在地マーカーを設置
    $('.js-move-map-center').on('click', () => {

      // メニューを閉じる
      $('#page-location').popup('close');

      // 初期化（GPS追跡停止、現在地マーカ非表示）
      $('.js-move-center').trigger("click");

      // 現在地マーカの表示有効範囲（動物園内）
      var minLoc = that.map.createLatLng(minLat, minLng);
      var maxLoc = that.map.createLatLng(maxLat, maxLng);

      // 閲覧中の地図の中心座標を取得
      var latlng = that.map.getCenter();

      // 閲覧中の地図の中心座標が表示有効範囲内の場合のみ...
      if (
        latlng.lat() > minLoc.lat() &&
        latlng.lng() > minLoc.lng() &&
        latlng.lat() < maxLoc.lat() &&
        latlng.lng() < maxLoc.lng()
      ) {

        // 現在地マーカを表示
        that.map.displayCurrentLocationMarker(latlng);

        // 現在地マーカ非表示ボタンを有効化
        $('.js-move-center').css('color', 'black');

      }

    });

    // 「表示しない」ボタン: 現在地マーカが非表示の場合、現在地マーカ非表示ボタンをグレーアウト
    $('.js-move-center').css('color', 'darkgray');

    // 「表示しない」ボタン: 現現在地マーカを非表示
    $('.js-move-center').on('click', () => {

      // TODO: IHCityTakatsukiに処理が割当てらているため、一旦無効にする
      return false;

      // メニューを閉じる
      $('#page-location').popup('close');

      // 「自動的に取得」ボタンで現在地を表示している場合、現在地の自動更新・描画を停止
      if (watchID) {
        navigator.geolocation.clearWatch(watchID);
        watchID = null;
      }

      // 現在地マーカが表示されている場合のみ...
      if (that.map.existCurrentLocationMarker()) {

        // 現在地マーカーを削除
        that.map.clearCurrentLocationMarker();

        // 現現在地マーカ非表示ボタンを再びグレーアウト
        $('.js-move-center').css('color', 'darkgray');

      }

    });

  }
}



// WEBPACK FOOTER //
// ./map/js/ih/Controller.js